<template>
<div class="dataPanelBinding">
  <el-card shadow="never">{{ projectName }}</el-card>
  <div class="box">
    <div class="group" :class="'group' + gindex" v-for="(group, gindex) in data" :key="gindex">
      <div v-if="!group.content" class="checkboxGroup">
        <el-checkbox-group v-model="tabPosition" :min="1" size="small">
          <el-checkbox-button label="0">储能</el-checkbox-button>
          <el-checkbox-button label="1">光伏</el-checkbox-button>
          <el-checkbox-button label="2">负载</el-checkbox-button>
          <el-checkbox-button label="3">充电桩</el-checkbox-button>
          <el-checkbox-button label="4">并网点</el-checkbox-button>
        </el-checkbox-group>
      </div>
      <div class="imgList">
        <div class="cls-default" :class="{'one': group.content && cindex === 0, 'two': group.content && cindex === 1, 'three': group.content && cindex === 2, 'four': group.content && cindex === 3, 'five': group.content && cindex === 4, 'six': group.content && cindex === 5, 'seven': group.content && cindex === 6, 'other': !group.content}" v-for="(item, cindex) in group.children" :key="cindex" draggable="true" @dragstart="onDragstart($event)" @dragend="onDragend($event)" @dragover="onDragover($event)" @drop="onDrop($event)" :panelId="item.panelId">
          <p v-if="group.content" class="closeIcon" @click="onClose(item)">
            <i class="el-icon-close"></i>
          </p>
          <div class="content" @click="onClick(item, cindex)">
            <el-tooltip class="item" effect="light" :content="item.panelName" :open-delay="500" placement="left">
              <img :data-id="gindex+'-'+cindex" :panelId="item.panelId" class="cls-img" :src="item.src" alt="">
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="radioBtn">
      <el-radio-group v-model="radio" size="mini">
        <el-radio-button label="0">2D场景</el-radio-button>
        <el-radio-button label="1">3D场景</el-radio-button>
      </el-radio-group>
    </div> -->
    <div class="centerPic">
      <el-carousel indicator-position="outside" :autoplay="false" ref="carousel" trigger="click">
        <el-carousel-item v-for="(item, index) in centerImgs" :key="index" name="index">
          <el-tooltip class="item" effect="dark" :content="item.panelName" placement="top">
          <img :src="item.src" alt="" @click="onClick(item, 7)" style="width: 380px;">
          </el-tooltip>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <el-button class="saveBtn" type="primary" @click="onSave()">保存</el-button> -->
  </div>

  <el-dialog title="面板数据点绑定" :visible.sync="isDataBindingDialog" :modal-append-to-body="false" :before-close="handleClose">
    <div v-if="dataList.formObjects" class="s1">
      <div class="row">
        <p class="title">表单类型</p>
        <el-button @click="addFormObjects()" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
        <div v-for="(formItem, formIndex) in dataList.formObjects" :key="formIndex" style="margin-top: 5px;">
          <el-input v-model="formItem.name" style="width: 200px;"></el-input>
          <span style="width: 200px;display: inline-block;margin-left: 50px;">
            <el-radio-group v-model="formItem.kind" @change="changeKind('form', formItem, formIndex)">
              <el-radio :label="1">按项目搜</el-radio>
              <el-radio :label="0">按ems搜</el-radio>
            </el-radio-group>
          </span>
          <span>
            <el-select v-model="formItem.searchKey" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="(query) => remoteMethod(query, formIndex)" style="width: 200px;">
              <el-option v-for="formItem1 in formOptions[formIndex]" :key="formItem1.value" :label="formItem1.name" :value="formItem1.value">
              </el-option>
            </el-select>
          </span>
        </div>
      </div>
    </div>
    <div v-if="dataList.listObjects" class="s2">
      <div class="row">
        <p class="title">列表类型</p>
        <el-button @click="addListObjects()" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
        <div v-for="(listItem, listIndex) in dataList.listObjects" :key="listIndex" style="margin-top: 5px;">
          <el-input v-model="listItem.name" style="width: 200px;"></el-input>
          <span style="width: 250px;display: inline-block;margin-left: 50px;">
            <el-radio-group v-model="listItem.kind" @change="changeKind('list', listItem, listIndex)">
              <el-radio :label="1">按项目搜</el-radio>
              <el-radio :label="0">按ems搜</el-radio>
            </el-radio-group>
          </span>
          <span>
            <el-select v-model="listItem.searchKey" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="(query) => remoteMethod(query, listIndex)" style="width: 200px;">
              <el-option v-for="listItem1 in listOptions[listIndex]" :key="listItem1.value" :label="listItem1.name" :value="listItem1.value">
              </el-option>
            </el-select>
          </span>
        </div>
      </div>
    </div>
    <div v-if="dataList.picObjects" class="s3">
      <div class="row">
        <p class="title">图标类型</p>
        <el-button @click="addPicObjects()" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
        <div v-for="(picItem, picIndex) in dataList.picObjects" :key="picIndex" style="margin-top: 5px;">
          <el-input v-model="picItem.name" style="width: 200px;"></el-input>
          <span style="width: 250px;display: inline-block;margin-left: 50px;">
            <el-radio-group v-model="picItem.kind" @change="changeKind('pic', picItem, picIndex)">
              <el-radio :label="1">按项目搜</el-radio>
              <el-radio :label="0">按ems搜</el-radio>
            </el-radio-group>
          </span>
          <span>
            <el-select v-model="picItem.searchKey" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="(query) => remoteMethod(query, picIndex)" style="width: 200px;">
              <el-option v-for="picItem1 in picOptions[picIndex]" :key="picItem1.value" :label="picItem1.name" :value="picItem1.value">
              </el-option>
            </el-select>
          </span>
        </div>
      </div>
    </div>
    <div v-if="dataList.chartObjects" class="s4">
      <div class="row">
        <p class="title">图表类型</p>
        <el-button @click="addChartObjects()" type="primary" size="mini" icon="el-icon-plus" circle></el-button>
        <div v-for="(chartItem, chartIndex) in dataList.chartObjects" :key="chartIndex" style="margin-top: 5px;">
          <el-input v-model="chartItem.name" style="width: 200px;"></el-input>
          <span style="width: 250px;display: inline-block;margin-left: 50px;">
            <el-radio-group v-model="chartItem.kind" @change="changeKind('chart', chartItem, chartIndex)">
              <el-radio :label="1">按项目搜</el-radio>
              <el-radio :label="0">按ems搜</el-radio>
            </el-radio-group>
          </span>
          <span>
            <el-select v-model="chartItem.searchKey" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="(query) => remoteMethod(query, chartIndex)" style="width: 200px;">
              <el-option v-for="chartItem1 in chartOptions[chartIndex]" :key="chartItem1.value" :label="chartItem1.name" :value="chartItem1.value">
              </el-option>
            </el-select>
          </span>
        </div>
      </div>
    </div>
    <div class="footer" style="text-align: center;">
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import PROJECTAPI from '@/api/project';
import API from '@/api/dataPanelConfig';
import {
  panelPic
} from './panelPic';
import {
  centerImages
} from '@/utils/centerImages';
export default {
  name: "Toolbar",
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      startIndex: "",
      endIndex: "",
      data: [{
          group: "left-show",
          content: true,
          children: [{
              panelId: 0,
              panelName: "无",
              src: "../../../../static/images/boss/panelPic/无.png",
              type: 0
            },
            {
              panelId: 0,
              panelName: "无",
              src: "../../../../static/images/boss/panelPic/无.png",
              type: 1
            },
            {
              panelId: 0,
              panelName: "无",
              src: "../../../../static/images/boss/panelPic/无.png",
              type: 2
            },
            {
              panelId: 0,
              panelName: "无",
              src: "../../../../static/images/boss/panelPic/无.png",
              type: 3
            },
            {
              panelId: 0,
              panelName: "无",
              src: "../../../../static/images/boss/panelPic/无.png",
              type: 4
            },
            {
              panelId: 0,
              panelName: "无",
              src: "../../../../static/images/boss/panelPic/无.png",
              type: 5
            },
            {
              panelId: 0,
              panelName: "无",
              src: "../../../../static/images/boss/panelPic/无.png",
              type: 6
            }
          ]
        },
        {
          group: "right-show",
          content: false,
          children: []
        }
      ],
      tabPosition: ['0'],
      radio: '0',
      centerImgs: [],
      isDataBindingDialog: false,
      dataList: {
        formObjects: [{
          name: '',
          kind: '',
          searchKey: ''
        }],
        listObjects: [{
          name: '',
          kind: '',
          searchKey: ''
        }],
        picObjects: [{
          name: '',
          kind: '',
          searchKey: ''
        }],
        chartObjects: [{
          name: '',
          kind: '',
          searchKey: ''
        }]
      },
      formOptions: [],
      listOptions: [],
      picOptions: [],
      chartOptions: [],
      keyWord: '',
      currItem: {},
      currIndex: 0,
      panelDataId: 0,
      panelId: 0,
      type: 'form',
      currPanel: {},
      allPanelData: [],
      currentItem:{}
    };
  },
  created() {
    this.searchAllPanelData();
    this.centerImgs = centerImages
  },
  watch: {
    tabPosition(val) {
      if (val.length == 0) {
        this.$message.warning("请至少选中一条！");
        return false;
      } else {
        this.searchAllPanelTemplateByScene();
      }
    }
  },
  methods: {
    searchAllPanelData() {
      let params = {
        projectId: this.projectId
      };
      let activeIndex = 0
      PROJECTAPI.searchAllPanelData(params).then(res => {
        if (res.data.code == 200) {
          if (res.data.data && res.data.data.length > 0) {
            let result = res.data.data;

            result = this.deleteObject(result);
            activeIndex = this.getActiveIndex(result)
            this.allPanelData = result;
            for (let i in result) {
              for (let j in panelPic) {
                if (result[i].panelId == panelPic[j].panelId) {
                  result[i].src = panelPic[j].src;
                }
              }
            }
            for (let j in this.data[0].children) {
              for (let i in result) {
                if (this.data[0].children[j].type == result[i].type) {
                  this.data[0].children[result[i].type] = result[i];
                }
              }
            }
          }
          //激活当前id
          this.$refs.carousel.setActiveItem(activeIndex)
        }
        this.searchAllPanelTemplateByScene();
      });
    },
    //获取当前激活的轮播图
    getActiveIndex(data){
      let list = []
      centerImages.forEach(item=>{
        list.push(item.panelId)
      })
      let active = 0
      if(data.length>0){
        data.forEach(item=>{
          if(list.includes(item.panelId)){
            active = list.map(it=>it).indexOf(item.panelId)
            for(let i=0;i<list.length;i++){
              if(item.panelId==list[i]){
                this.currentItem = item
                break
              }
            }
          }
        })
      }
      return active
    },
    //删除数组对象中的重复对象
    deleteObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return (Number(a) - Number(b));
        });
        var str = '';
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    searchAllPanelTemplateByScene() {
      let params = {
        scenes: this.tabPosition
      };
      PROJECTAPI.searchAllPanelTemplateByScene(params).then(res => {
        if (res.data.code == 200 && !res.data.errors) {
          let result = res.data.data;
          let picList = [];
          for (let i in panelPic) {
            for (let j in result) {
              if (panelPic[i].panelId == result[j].panelId) {
                picList.push(panelPic[i]);
              }
            }
          }
          this.data[1].children = picList;
        }
        for (let j in this.data[0].children) {
          for (let i in this.data[1].children) {
            if (this.data[1].children[i].panelId && this.data[0].children[j].panelId && this.data[1].children[i].panelId == this.data[0].children[j].panelId) {
              this.data[1].children.splice(i, 1);
            }
          }
        }
      });
    },
    onDragstart(event) {
      this.startIndex = event.target.getAttribute("data-id");
    },
    onDragend(event) {
      let startGroupIndex = this.startIndex.split("-")[0];
      let startChildIndex = this.startIndex.split("-")[1];
      if (this.endIndex != "") {
        let endGroupIndex = this.endIndex.split("-")[0];
        let endChildIndex = this.endIndex.split("-")[1];
        let startObj = this.data[startGroupIndex].children[startChildIndex];
        let endObj = this.data[endGroupIndex].children[endChildIndex];
        if (this.data[endGroupIndex].group === "source") {
          //往资源区拖拽时  不做任何替换操作
          return;
        }
        this.data[endGroupIndex].children.splice(endChildIndex, 1, startObj);
        if (this.data[startGroupIndex].group !== "source") {
          //拖拽起始区域不是 source时  把起始区域替换成拖拽后区域的数据
          this.data[startGroupIndex].children.splice(startChildIndex, 1, endObj);
        }
        let arr = this.data[1].children;
        arr.splice(arr.findIndex(e => e.panelId == 0), 1);
      }
    },
    onDrop(event) {
      if (event.target.className.indexOf("cls-img") > -1) {
        this.endIndex = event.target.getAttribute("data-id");
      } else {
        this.endIndex = event.target.parentElement.getAttribute("data-id");
      }
    },
    onDragover(event) {
      event.preventDefault();
    },
    // onSave() {
    //   let activeIndex = this.$refs.carousel.activeIndex;
    //   let panelIds = [];
    //   this.data[0].children.forEach(e => {
    //     if (e.panelId != 0) {
    //       panelIds.push(e.panelId)
    //     }
    //   });
    //   panelIds.push(this.centerImgs[activeIndex].panelId);
    //   let params = {
    //     panelIds: panelIds,
    //     projectId: this.projectId
    //   };
    //   PROJECTAPI.saveAllPanelDataBySortedAndProjectId(params).then(res => {
    //     if (res.data.code == 200) {
    //       this.$message.success(res.data.data)
    //     }
    //   });
    // },
    onClose(item) {
      if (item.panelId != 0) {
        let blank = {
          panelId: 0,
          panelName: "无",
          src: "../../../../static/images/boss/panelPic/无.png"
        };
        this.data[0].children = this.data[0].children.map(t => {
          return t.panelId == item.panelId ? blank : t;
        })
        this.data[1].children.push(item);
      }
    },
    handleClose(done) {
      done();
    },
    onClick(item, cindex) {
      if (item.panelId != 0) {
        this.currPanel = item;
        this.currPanel.type = cindex;
        this.isDataBindingDialog = true;
        this.searchPanelTemplateById(item.panelId);
      }
    },
    searchPanelTemplateById(id) {
      let params = {
        id: id
      };
      API.searchPanelTemplateById(params).then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data;
        }
      });
    },
    addFormObjects() {
      this.dataList.formObjects.push({
        name: '',
        kind: '',
        searchKey: ''
      });
    },
    addListObjects() {
      this.dataList.listObjects.push({
        name: '',
        kind: '',
        searchKey: ''
      });
    },
    addPicObjects() {
      this.dataList.picObjects.push({
        name: '',
        kind: '',
        searchKey: ''
      });
    },
    addChartObjects() {
      this.dataList.chartObjects.push({
        name: '',
        kind: '',
        searchKey: ''
      });
    },
    changeKind(type, item, index) {
      this.type = type;
      this.currItem = item;
      this.currIndex = index;
      this.remoteMethod(this.keyWord, index);
    },
    remoteMethod(query, index) {
      this.keyWord = query;
      if (query != "") {
        try {
          let params = {
            projectId: this.projectId,
            query: query,
            kind: this.currItem.kind
          };
          PROJECTAPI.fuzzySearchFields(params).then(res => {
            if (res.data.code == 200) {
              if (this.type == "form") {
                this.$set(this.formOptions, index, res.data.data);
                this.formOptions[index] = res.data.data;
              } else if (this.type == "list") {
                this.$set(this.listOptions, index, res.data.data);
                this.listOptions[index] = res.data.data;
              } else if (this.type == "pic") {
                this.$set(this.picOptions, index, res.data.data);
                this.picOptions[index] = res.data.data;
              } else if (this.type == "chart") {
                this.$set(this.chartOptions, index, res.data.data);
                this.chartOptions[index] = res.data.data;
              }
            }
          });
        } catch (e) {
          console.log(e)
        }
      }
    },
    onSubmit() {
      let objects = [];
      if (this.dataList.formObjects) {
        this.dataList.formObjects.forEach(ele => {
          if (ele.searchKey) {
            objects.push({
              key: ele.searchKey
            })
          }
        });
      }
      if (this.dataList.listObjects) {
        this.dataList.listObjects.forEach(ele => {
          if (ele.searchKey) {
            objects.push({
              key: ele.searchKey
            })
          }
        });
      }
      if (this.dataList.picObjects) {
        this.dataList.picObjects.forEach(ele => {
          if (ele.searchKey) {
            objects.push({
              key: ele.searchKey
            })
          }
        });
      }
      if (this.dataList.chartObjects) {
        this.dataList.chartObjects.forEach(ele => {
          if (ele.searchKey) {
            objects.push({
              key: ele.searchKey
            })
          }
        });
      }
      let type = this.currPanel.type;
      // if (this.currPanel.panelId != 120005 && this.currPanel.panelId != 120006) {
      //   if (this.endIndex != "") {
      //     type = this.endIndex.split("-")[1];
      //   } else {
      //     this.$message.warning("绑点前请先排序！");
      //     return false;
      //   }
      // } else {
      //   type = 7;
      // }
      let panelDataId = 0;
      if (this.allPanelData.length > 0 && this.allPanelData[type]) {
        panelDataId = this.allPanelData[type].panelDataId;
      }
      if(this.currentItem && this.currentItem.panelDataId){
        panelDataId = this.currentItem.panelDataId
      }
      let params = {
        combineId: 0,
        objects: objects,
        panelDataId: panelDataId,
        panelId: this.currPanel.panelId,
        panelName: this.currPanel.panelName?this.currPanel.panelName:this.currPanel.name,
        picName: '',
        projectId: this.projectId,
        type: Number(type)
      };
      PROJECTAPI.saveOrUpdateSimulationPanelData(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("保存成功！");
          this.isDataBindingDialog = false;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.dataPanelBinding {

  .box {
    height: 65vh;
    padding-top: 15px;
    position: relative;
  }

  .imgList {
    margin-top: 5px;
    overflow-y: auto;
    cursor: pointer;
  }

  .cls-default {
    width: 300px;
    height: 150px;
    border: 1px solid #ccc;
  }

  .closeIcon {
    position: absolute;
    right: 0px;
    cursor: pointer;
  }

  .cls-img {
    width: 300px;
    height: 150px;
  }

  .group0 {
    background: #d8e8fe;
    border-radius: 4px;
    float: left;
    width: calc(79% - 5px);
    height: 100%;
  }

  .group1 {
    float: left;
    width: 21%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 5px;
    // overflow-y: auto;
  }

  .one {
    top: 80px;
    left: 1%;
    position: absolute;
  }

  .two {
    top: 50%;
    left: 1%;
    position: absolute;
    transform: translateY(-35%);
  }

  .three {
    bottom: 35px;
    left: 1%;
    position: absolute;
  }

  .four {
    top: 80px;
    left: 58%;
    position: absolute;
  }

  .five {
    top: 50%;
    left: 58%;
    position: absolute;
    transform: translateY(-35%);
  }

  .six {
    bottom: 35px;
    left: 58%;
    position: absolute;
  }

  .seven {
    top: 40px;
    left: 40%;
    position: absolute;
    transform: translateX(-50%);
  }

  .other {
    margin-bottom: 1vh;
  }

  .radioBtn {
    width: 100px;
    top: 35%;
    left: 24%;
    position: absolute;
    transform: translateX(-40%);
  }

  .centerPic {
    width: 400px;
    height: 400px;
    top: 35%;
    left: 40%;
    position: absolute;
    transform: translateX(-50%);
    cursor: pointer;
  }

  .saveBtn {
    bottom: 3%;
    left: 40%;
    position: absolute;
    transform: translateX(-50%);
  }

  .row {
    border: 1px solid #ccc;
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 15px 20px;

    .title {
      border-bottom: 1px solid #ccc;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 10px;
    }
  }
}
</style>
<style lang="scss">
.checkboxGroup .el-checkbox-button__inner,
.checkboxGroup .el-checkbox-group {
  display: block !important;
}

.checkboxGroup .el-checkbox-button.is-disabled .el-checkbox-button__inner {
  background-color: #0261E4 !important;
}

.radioBtn .el-radio-button__inner,
.radioBtn .el-radio-group {
  display: block !important;
}

.radioBtn .el-radio-button .el-radio-button__inner {
  border-radius: 4px !important;
}

.radioBtn .el-radio-button:first-child .el-radio-button__inner {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/dataPanelBinding.vue